import React from 'react';
import { Tooltip, Icon, Upload, Modal } from 'antd';
import Select from 'react-select';
import { urlName } from '../../../config';
import { LCInput } from '../../../frameWork';
import FormField from '../../../components/FormField';
const imageUploadType = [{ label: "Login Background", value: "loginBackground" }, { label: "Sign up Background", value: "signupBackground" }, { label: "Domain Logo", value: "domainLogo" }, { label: "Favicon", value: "favicon" }]
const currentLoginUrl = `/images/${urlName}/login.png`;
const currentSignupUrl = `/images/${urlName}/login.png`;
const currentLogoUrl = `/images/${urlName}/login-text.png`;
const currentFaviconUrl = `/images/${urlName}/favicon.png`;
var languageFile = require("../../../../public/languages/Translation");

export const ImageUpload = props => {
    return (<div className="domainlevel-upload">
        <h3>Domain Level Image Upload</h3>
        <div className="current-logo">
            <h3 style={{ fontSize: 16 }}>Current Logos</h3>
            <div className="logo-list">
                < RenderCurrentImage
                    title="Login Background"
                    infoText="It will display in Login page background"
                    hasLogo={props.whiteLabelImages.loginBackground}
                    defaultUrl={currentLoginUrl} />
                < RenderCurrentImage
                    title="Sign up Background"
                    infoText="It will display in sign up page background"
                    hasLogo={props.whiteLabelImages.signupBackground}
                    defaultUrl={currentSignupUrl} />
                < RenderCurrentLogo
                    title="Domain Logo"
                    infoText="It will display in login and signup page"
                    hasLogo={props.whiteLabelImages.domainLogo}
                    defaultUrl={currentLogoUrl} />
                < RenderCurrentLogo
                    title="Favicon"
                    infoText="It will display on the top-left corner of the browser tab"
                    hasLogo={props.whiteLabelImages.favicon}
                    defaultUrl={currentFaviconUrl} />
            </div>
        </div>
        <div className="replace-logo">
            <div className="upload-instruction">
                <h4>Replace Logo</h4>
                <p>Choose which type logo you want to change using the dropdown options and upload logo.</p>
            </div>
            <div className="upload-setup">
                <div className="upload-type">
                    <span>{languageFile[localStorage.getItem('language')]["28301"]}</span>
                    <Select
                        placeholder="image"
                        options={imageUploadType}
                        value={props.selectedUploadType}
                        onChange={props.changeUploadType}
                    />
                </div>
                <div className="upload-image">
                    <Upload
                        action="//jsonplaceholder.typicode.com/posts/"
                        listType="picture-card"
                        fileList={props.fileList}
                        onPreview={props.handlePreview}
                        onChange={props.handleChange}
                        customRequest={props.imageFile}
                        onRemove={props.removeImage}
                        className="upload-wrap"
                    >
                        {props.fileList.length >= 1 ? null :
                            <div>
                                <span ><img src="/images/add-image.png" /></span>
                                <div className="ant-upload-text" style={{ marginTop: 10 }} >Upload here</div>
                            </div>}
                    </Upload>
                    <Modal visible={props.previewVisible} footer={null} onCancel={props.handlePreviewCancel}>
                        <img alt="example" style={{ width: '100%' }} src={props.previewImage} />
                    </Modal>
                </div>
            </div>
        </div>
    </div>)
}
const RenderCurrentImage = (props) => {
    return <div className="logo-list__item">
        <h4>
            <span>
                {props.title}
            </span>
            <Tooltip title={props.infoText}>
                <Icon type="info-circle" />
            </Tooltip>
        </h4>
        <span className="item-image">{props.hasLogo && <img width="120" height="600" src={props.hasLogo + "?time=" + Date.now()} alt="image" /> ||
            <img width="120" height="600" src={props.defaultUrl + "?time=" + Date.now()} alt="image" />
        }</span>
    </div>
}

const RenderCurrentLogo = (props) => {
    return <div className="logo-list__item">
        <h4>
            <span>
                {props.title}
            </span>
            <Tooltip title={props.infoText}>
                <Icon type="info-circle" />
            </Tooltip>
        </h4>
        <span className="item-image">
            {props.hasLogo && <img src={props.hasLogo + "?time=" + Date.now()} alt="image" /> ||
                <img src={props.defaultUrl + "?time=" + Date.now()} alt="image" />
            }
        </span>
    </div>
}